module.exports = __webpack_public_path__ + "img/pijlkop-groen.7b7b2a507245cd8aad88e8271508b787.svg";